// extracted by mini-css-extract-plugin
export var header = "_su-1";
export var maskBottom = "_su-6";
export var maskMiddle = "_su-7";
export var maskTop = "_su-5";
export var root = "_su-0";
export var scrollDownButton = "_su-3";
export var scrollDownButtonHidden = "_su-4";
export var viewport = "_su-2";